export const lgModalConfig: any = {
  class: 'modal-lg modal-dialog-centered',
  backdrop: true,
  ignoreBackdropClick: true,
  keyboard: false,
};

export const mdModalConfig: any = {
  class: 'modal-md modal-dialog-centered',
  backdrop: true,
  ignoreBackdropClick: true,
  keyboard: false,
};

export const xlModalConfig: any = {
  class: 'modal-xl modal-dialog-centered',
  backdrop: true,
  ignoreBackdropClick: true,
  keyboard: false,
};

export const mdModalConfigCanClose: any = {
  class: 'modal-md modal-dialog-centered',
  backdrop: true,
  ignoreBackdropClick: false,
  keyboard: true,
};

export const lgModalConfigCanClose: any = {
  class: 'modal-lg modal-dialog-centered',
  backdrop: true,
  ignoreBackdropClick: false,
  keyboard: true,
};
